
import { CubeCluster } from './cube-cluster.js';

// The cube cluster behind the page. Each section says which layout the cubes
// form (data-shape) and which side of the page they go to (data-side).
window.cubeCluster = null;   // set below once the scene exists; see the "load" check above
const params = new URLSearchParams(location.search);
const canvas = document.getElementById('scene');

function readPanel(panel) {
  const shape = panel?.dataset.shape;
  return {
    shape: shape === 'home' || CubeCluster.shapes.includes(shape) ? shape : 'home',
    side: panel?.dataset.side === 'left' ? 'left' : 'right',
  };
}

// Building the scene keeps the main thread busy for a moment, so let the copy
// paint first: wait for one frame to go out before starting.
await new Promise((resolve) => requestAnimationFrame(() => setTimeout(resolve)));

// Start on whichever section the page opens at (it may be restored mid-page).
const first = readPanel(document.querySelector('.panel.is-active'));
let cluster;
try {
  cluster = new CubeCluster(canvas, {
    shape: first.shape,
    side: first.side,
    // Keeps to one half of the page, below the top bar; on tall screens it
    // sits in a band at the top (compactAspect matches the CSS media query).
    layout: { slot: 0.54, margin: 0, top: 64, compactAspect: 1 },
    scrollEffects: true,
    pixelRatio: params.has('dpr') ? parseFloat(params.get('dpr')) || 1 : null,
    time: params.has('freeze') ? parseFloat(params.get('freeze')) || 0 : null,
    quality: params.get('quality') || undefined,   // 'auto', 'high' or 'low'
  });
} catch (err) {
  document.documentElement.classList.add('no-webgl');
  throw err;
}

// A section has to stay active for a moment before the cubes react, so a
// fast scroll past several goes straight to the last.
const SETTLE_MS = 120;
let panelTimer = 0;
addEventListener('panelchange', (e) => {
  const { shape, side } = readPanel(e.detail.panel);
  clearTimeout(panelTimer);
  panelTimer = setTimeout(() => cluster.goTo(shape, side), SETTLE_MS);
});
cluster.addEventListener('ready', () => { window.__ready = true; });

// Public handle for scripting, e.g. cubeCluster.goTo('web', 'right').
window.cubeCluster = cluster;
